export const pos = {
  // Titres et en-têtes
  title: 'نقطة البيع',
  subtitle: 'محطة الصندوق',
  
  // Panier (Cart)
  cart: {
    title: 'السلة',
    empty: 'السلة فارغة',
    emptyMessage: 'أضف منتجات للبدء',
    items: 'منتج',
    itemsPlural: 'منتجات',
    total: 'المجموع',
    pay: 'ادفع',
    clear: 'إفراغ السلة',
    clearConfirm: 'هل أنت متأكد من أنك تريد إفراغ السلة؟',
    removeItem: 'حذف',
    quantity: 'الكمية',
    unitPrice: 'سعر الوحدة',
    lineTotal: 'مجموع السطر'
  },

  // Modal de paiement (CheckoutModal)
  checkout: {
    title: 'إتمام الدفع',
    receiptTitle: 'إيصال الصندوق',
    
    // Récapitulatif de commande
    orderSummary: {
      title: 'ملخص الطلب',
      subtotal: 'المجموع الفرعي',
      tva: 'الضريبة على القيمة المضافة',
      totalToPay: 'المجموع المطلوب دفعه'
    },

    // Informations client
    customer: {
      name: 'اسم العميل',
      namePlaceholder: 'اسم العميل',
      phone: 'الهاتف',
      phonePlaceholder: 'رقم الهاتف',
      notes: 'ملاحظات',
      notesPlaceholder: 'ملاحظات إضافية...'
    },

    // Méthodes de paiement
    paymentMethods: {
      title: 'طريقة الدفع',
      cash: 'نقداً',
      card: 'بطاقة بنكية',
      check: 'شيك',
      transfer: 'تحويل',
      mobile: 'المال المحمول'
    },

    // Montant reçu
    amountReceived: {
      title: 'المبلغ المستلم',
      placeholder: '0.00',
      quickAmounts: 'مبالغ سريعة',
      insufficient: 'مبلغ غير كافي',
      change: 'المتبقي'
    },

    // Boutons d'action
    actions: {
      cancel: 'إلغاء',
      finalize: 'إتمام',
      finalizeCredit: 'إتمام بالائتمان',
      processing: 'جاري المعالجة...',
      close: 'إغلاق',
      print: 'طباعة'
    },

    // Messages d'erreur
    errors: {
      insufficientAmount: 'يجب أن يكون المبلغ المستلم أكبر من أو يساوي المبلغ الإجمالي',
      insufficientAmountConfirm: 'المبلغ المستلم غير كافي. هل تريد إتمام البيع بالائتمان؟',
      paymentError: 'خطأ أثناء الدفع. يرجى المحاولة مرة أخرى.',
      emptyCart: 'السلة فارغة. أضف منتجات قبل المتابعة للدفع.'
    }
  },

  // Ticket de caisse (Receipt)
  receipt: {
    title: 'إيصال الصندوق',
    saleNumber: 'بيع رقم',
    client: 'العميل',
    articles: 'المنتجات',
    payment: 'الدفع',
    method: 'الطريقة',
    amountReceived: 'المبلغ المستلم',
    change: 'المتبقي',
    notes: 'ملاحظات',
    thankYou: 'شكراً لشرائك!',
    keepTicket: 'احتفظ بهذا الإيصال',
    subtotal: 'المجموع الفرعي',
    total: 'المجموع'
  },

  // Barre de statut (StatusBar)
  statusBar: {
    currentSale: 'بيع جاري',
    totalItems: 'إجمالي المنتجات',
    totalAmount: 'المبلغ الإجمالي',
    ready: 'جاهز',
    processing: 'جاري المعالجة...',
    offline: 'غير متصل',
    online: 'متصل'
  },

  // Grille de produits (ProductGrid)
  productGrid: {
    title: 'المنتجات',
    search: 'البحث عن منتج...',
    noProducts: 'لم يتم العثور على منتجات',
    noProductsWithCriteria: 'لم يتم العثور على منتجات بهذه المعايير',
    noProductsAvailable: 'لا توجد منتجات متاحة',
    addToCart: 'أضف إلى السلة',
    outOfStock: 'نفذ من المخزون',
    lowStock: 'مخزون منخفض',
    loading: 'جاري تحميل المنتجات...',
    error: 'خطأ في تحميل المنتجات',
    retry: 'إعادة المحاولة',
    stock: 'المخزون',
    noBarcode: 'بدون رمز',
    orders: 'الطلبات',
    newOrder: 'طلب جديد',
    order: 'طلب',
    articles: 'عناصر',
    categories: {
      all: 'الكل',
      navigation: 'تنقل الفئات'
    },
    // Commentaires et éléments d'interface
    header: 'رأس مع البحث',
    productGrid: 'شبكة المنتجات',
    categoryFilters: 'فلاتر الفئات مع التنقل',
    leftArrow: 'السهم الأيسر',
    rightArrow: 'السهم الأيمن',
    categoryContainer: 'حاوية الفئات مع التمرير'
  },

  // Clavier virtuel (VirtualKeypad)
  keypad: {
    title: 'لوحة المفاتيح الرقمية',
    quantity: 'الكمية',
    price: 'السعر',
    total: 'المجموع',
    clear: 'مسح',
    enter: 'إدخال',
    backspace: 'تراجع'
  },

  // Pavé virtuel (VirtualKeypad)
  virtualKeypad: {
    title: 'لوحة المفاتيح الرقمية',
    clearCart: 'إفراغ السلة',
    clearCartConfirm: 'هل أنت متأكد من أنك تريد إفراغ السلة؟',
    selectors: {
      quantity: 'الكمية',
      discount: 'الخصم',
      price: 'السعر'
    },
    buttons: {
      toggleSign: '+/-',
      backspace: '⌫',
      decimal: '.',
      enter: 'إدخال'
    },
    actions: {
      clear: 'مسح',
      backspace: 'تراجع',
      toggleSign: 'تغيير الإشارة'
    }
  },

  // Layouts spécifiques
  layouts: {
    retail: {
      title: 'التجارة بالتجزئة',
      products: 'المنتجات',
      categories: 'الفئات'
    },
    restaurant: {
      title: 'المطعم',
      menu: 'القائمة',
      tables: 'الطاولات',
      orders: 'الطلبات الجارية',
      table: 'طاولة',
      status: {
        active: 'نشطة',
        empty: 'فارغة',
        reserved: 'محجوزة'
      },
      orderStatus: {
        preparing: 'قيد التحضير',
        ready: 'جاهز'
      }
    },
    services: {
      title: 'الخدمات',
      services: 'الخدمات',
      clients: 'العملاء',
      appointments: 'المواعيد',
      timer: 'المؤقت',
      startTimer: 'بدء',
      stopTimer: 'إيقاف',
      resetTimer: 'إعادة تعيين',
      serviceTime: 'وقت الخدمة',
      newClient: 'عميل جديد',
      searchClient: 'البحث عن عميل...',
      lastVisit: 'آخر زيارة',
      confirmed: 'مؤكد',
      pending: 'في الانتظار'
    },
    workshop: {
      title: 'الورشة',
      quoteLines: 'أسطر العرض',
      addLine: 'إضافة سطر',
      description: 'الوصف',
      quantity: 'الكمية',
      unitPrice: 'سعر الوحدة',
      total: 'المجموع',
      clients: 'العملاء',
      newClient: 'عميل جديد',
      searchClient: 'البحث عن عميل...',
      quotePreview: 'معاينة العرض',
      quoteNumber: 'عرض رقم',
      date: 'التاريخ',
      client: 'العميل'
    }
  },

  // Notifications
  notifications: {
    paymentSuccess: 'تم الدفع بنجاح!',
    saleSaved: 'تم حفظ البيع بنجاح',
    error: 'خطأ',
    success: 'نجح',
    warning: 'تحذير',
    info: 'معلومات'
  },

  // Messages généraux
  messages: {
    loading: 'جاري التحميل...',
    saving: 'جاري الحفظ...',
    error: 'حدث خطأ',
    success: 'تمت العملية بنجاح',
    confirm: 'هل أنت متأكد؟',
    cancel: 'إلغاء',
    ok: 'موافق',
    yes: 'نعم',
    no: 'لا'
  },

  // Formats de date et monnaie
  formats: {
    currency: '€',
    date: 'DD/MM/YYYY',
    time: 'HH:mm',
    datetime: 'DD/MM/YYYY HH:mm'
  }
}; 